import { jsx as c } from "react/jsx-runtime";
import { INTERNAL_LINK_SELECTOR_NOT_MODULES as m } from "../../constants/modules/index.js";
import { withDatasourceCheck as x, RichText as a } from "@sitecore-jss/sitecore-jss-nextjs";
const p = ({ fields: t, rendering: o }) => t != null && t.text ? /* @__PURE__ */ c(
  a,
  {
    "data-test-id": o == null ? void 0 : o.componentName,
    field: t.text,
    internalLinksSelector: m
  }
) : null, h = x()(p);
export {
  h as RichTextBlock
};
